import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Card, CardBody } from "reactstrap";

function ClientStatusStrip({ status, reason, t }) {
  const {
    isActive,
    isActionRequired,
    isBlocked,
    statusLabel,
  } = status;

  const trimmedReason =
    typeof reason === "string" && reason.trim() ? reason.trim() : "";

  let label = t("clientDashboardStatusActive", "Active and ready to book");
  let hint = "";
  let variant = "active";
  let showProfileLink = false;

  if (isBlocked) {
    variant = "action";
    label = t("clientDashboardStatusBlocked", "Account restricted");
    hint = t(
      "clientDashboardStatusBlockedHint",
      "Please contact JobArk if you need help restoring access."
    );
  } else if (isActionRequired) {
    variant = "action";
    label = t("clientDashboardStatusActionRequired", "Action required");
    if (trimmedReason) {
      hint = trimmedReason;
    } else {
      hint = t(
        "clientDashboardStatusActionHint",
        "Complete your company profile to continue requesting staff."
      );
      showProfileLink = true;
    }
  } else if (!isActive) {
    variant = "action";
    label =
      statusLabel ||
      t("clientDashboardStatusPending", "Account pending review");
    hint = t(
      "clientDashboardStatusPendingHint",
      "We’ll notify you once your account has been reviewed."
    );
  }

  return (
    <Card
      className={`client-dashboard-status border-0 mb-4 client-dashboard-status--${variant}`}
    >
      <CardBody className="p-3 p-md-4 d-flex align-items-center gap-3">
        <span className="client-dashboard-status__icon" aria-hidden="true">
          <i
            className={`bx ${
              variant === "active" ? "bx-check-circle" : "bx-error-circle"
            }`}
          />
        </span>
        <div className="flex-grow-1">
          <div className="client-dashboard-status__label">{label}</div>
          {hint ? (
            <p
              className={`client-dashboard-status__hint mb-0${
                isActionRequired && trimmedReason
                  ? " client-dashboard-status__hint--reason"
                  : ""
              }`}
            >
              {hint}
              {showProfileLink ? (
                <>
                  {" "}
                  <Link to="/user/me" className="fw-semibold">
                    {t("clientMenuCompanyProfile", "Company Profile")}
                  </Link>
                </>
              ) : null}
            </p>
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
}

ClientStatusStrip.propTypes = {
  status: PropTypes.shape({
    isActive: PropTypes.bool,
    isActionRequired: PropTypes.bool,
    isBlocked: PropTypes.bool,
    statusLabel: PropTypes.string,
  }).isRequired,
  reason: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(ClientStatusStrip);
